import { Stats } from './stats';
import { New } from './new';
import { Actions } from './actions';
import css from './controls.module.scss';

interface Props {
    total: number;
}
export function Controls({ total }: Props) {
    return (
        <div className={css.controls}>
            <Stats total={total} />
            <New />
            <Actions />
        </div>
    );
}
